import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PropertyStatisticsResponse } from "../response/PropertyStatisticsResponse";

const API_VERSION = "v4";

const usePropertyStatistics = () => {
    return useQuery({
        queryKey: ['property-statistics'],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/statistics/property`);

                // Validasi response
                const validationResult = PropertyStatisticsResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid property statistics data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch property statistics`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default usePropertyStatistics;